import { AuthTokensInfo } from "../../accounts/models/AccountTypes";
import { Authentication } from "./Authentication";

export class RouteUtils {
    public static goHome() {
        window.open("/", "_self");
    }

    public static goLogin() {
        window.open("/login", "_self");
    }

    public static goSignup() {
        window.open("/signup", "_self");
    }

    public static goForgotPassword() {
        window.open("/forgot-password", "_self");
    }

    public static goChangePassword() {
        window.open("/change-password", "_self");
    }

    public static onLoggedIn(account: AuthTokensInfo) {
        Authentication.setUserAuth(account);
        Authentication.getCustomer();
    }

    public static onLoggedOut() {
        Authentication.clearUserAuth();
        Authentication.clearCustomer();
    }

    public static onReload() {
        // Load data
    }
}